import { WEB_GRAPHQL_ENABLED } from '../constants/experiments/config';
import { selectExperiment } from '../selectors/config';

const setGraphQlStatus = (state, apiClient) => {
  if (selectExperiment(state, WEB_GRAPHQL_ENABLED)) {
    apiClient?.enableGraphQl?.();
  }
};

export default setGraphQlStatus;
